<template>
    <div class="icon">
        <div class="icons">
            <img src="@/assets/djxc/icon.png" alt="">
            <div class="title">{{title}}</div>
        </div>
        <div class="more" v-if="more" @click="moreClick">
            {{moreText}}
        </div>
    </div>
</template>

<script>
    export default{
        props:{
            title:{
                type:String,
                default:""
            },
            more:{
                type:Boolean,
                default:false
            },
			moreText:{
                type:String,
                default:"更多"
			}
        },
        data(){
            return{

            }
        },
		methods: {
			moreClick(){
				this.$emit("moreClick")
			}
		},
    }
</script>


<style scoped lang="scss">
    .icon{
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: linear-gradient(180deg, #FDEEB2 0%, #FAD97A 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 1.6vh;
        margin-bottom: 1vh;
        .icons{
            display: flex;
            align-items: center;
            img{
                width: 4.5vh;
                height: 4.5vh;
            }
            .title{
                margin-left: 0.5vw;
                font-size: 2vh;
                font-weight: bold;
            }
        }
        .more{
            cursor: pointer;
        }
    }
</style>